import { ABScreen } from '../lib/ab/screen';
import '../lib/blk/all';
import { blkMakeSection } from '../lib/blk/render';
import { aTrackPage } from '../lib/mdl/a-track';
import { f_pages } from '../lib/mdl/f-page';
import { getCountry } from '../lib/me/me';
import { UIViewSpec } from '../lib/ui/view';
import { ySetLanguageOneOf } from '../lib/y/i18n';
import { YId } from '../lib/y/types';
import { ProducerMenu } from './menu';

export class ProducerCustomScreen extends ABScreen {
    constructor(private _page_id: YId) {
        super({});
    }

    protected override fillContent(content: UIViewSpec): Promise<any> {
        const promise = f_pages.get(this._page_id).then(page => {
            ySetLanguageOneOf(Object.keys(page.languages));
            this.ab_footer?.setLanguages(Object.keys(page.languages));
            const promises: Promise<any>[] = [];
            const sections = page.sections.filter(s => !(Object.keys(s.countries).length && !s.countries[getCountry()]));
            content.ui_add(sections.map((s, n) => blkMakeSection(s, n, this, promises, page.flags, () => new ProducerMenu)));
            return promises.length ? Promise.all(promises) : undefined;
        });

        aTrackPage('custom', { landing_page: this._page_id });

        return promise;
    }
}
